






import { Component, Vue, Prop } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import Highcharts from 'highcharts';

@Component
export default class BarChart extends Vue {
    /*----------------------------------*
     * Props
     *-----------------------------------*/
    @Prop({ default: () => {} }) data: { [key: string]: any };
    @Prop(String) selector: string;
    @Prop({ default: () => [] }) categories: string[];
    @Prop({ default: () => [] }) colors: string[];
    @Prop(String) xTitle: string;
    @Prop(String) yTitle: string;

    /*----------------------------------*
     * Data
     *-----------------------------------*/

    /*----------------------------------*
     * Computed
     *-----------------------------------*/

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    mounted() {
        this._drawChart();
    }

    /*----------------------------------*
     * Methods
     *-----------------------------------*/
    private _drawChart() {
        // 表示データ抽出
        const series = [{ data: [], colorByPoint: true }];
        for (let i = 0; i < this.categories.length; i++) {
            const category: string = this.categories[i];
            series[0].data.push(this.data[category]);
        }

        // 外部から色の配列が渡されてきたら利用
        // 色の数 < 棒の数 の場合、最初の色から繰り返される
        if (this.colors.length > 0) {
            series[0]['colors'] = this.colors;
        }

        // 描画設定
        const chartParam: { [key: string]: any } = {
            chart: {
                type: 'column',
            },
            credits: {
                enabled: false,
            },
            title: {
                text: '',
            },

            xAxis: [
                {
                    categories: this.categories,
                    title: {
                        text: this.xTitle,
                    },
                },
            ],
            yAxis: {
                min: 0,
                title: {
                    text: this.yTitle,
                },
            },
            legend: {
                enabled: false,
            },
            tooltip: {
                headerFormat: '<b>{point.x}</b>: {point.y}<br/>',
                pointFormat: '',
            },
            plotOptions: {
                column: {
                    dataLabels: {
                        enabled: true,
                    },
                },
            },
            series: series,
        };
        Highcharts.chart(this.selector, chartParam);
    }
}
